import React from 'react'
import DOMPurify from 'dompurify'

/**
 * EmailContent - Renders HTML email content safely
 * Prefers body_html over body_text for rich formatting
 */
function EmailContent({ html, text, fallback }) {
  const content = html || text || fallback

  // If we have HTML content, sanitize and render it
  if (html) {
    // DOMPurify: whitelist safe tags and attributes only
    const sanitizedHtml = DOMPurify.sanitize(html, {
      // Allow standard email formatting tags, block dangerous ones
      // (script, style, base, meta, form, iframe, object, embed are stripped by default)
      FORBID_TAGS: ['style', 'base', 'meta', 'form', 'iframe', 'object', 'embed', 'link'],
      FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur'],
      // Allow target attribute on links (we set it via hook below)
      ADD_ATTR: ['target'],
    })

    // Post-process: force all links to open in new tab
    const safeHtml = sanitizedHtml.replace(/<a\s/gi, '<a target="_blank" rel="noopener noreferrer" ')

    return (
      <div
        className="email-content"
        style={{
          fontFamily: 'inherit',
          lineHeight: 1.5,
          wordBreak: 'break-word'
        }}
        dangerouslySetInnerHTML={{ __html: safeHtml }}
      />
    )
  }

  // Otherwise render plain text with whitespace preserved
  return (
    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
      {content}
    </pre>
  )
}

export default EmailContent
